import { useRecoilValue } from 'recoil';
import {
    ReplanningStage,
    replanningStage,
} from '~/containers/viewer/explorer-sidebar/WorkflowSidebar/AdaptiveReplanningStep/replanningStages';
import useWorkflowSteps from '~/containers/viewer/explorer-sidebar/WorkflowStepper/useWorkflowSteps';
import {
    replanningEditingStructuresState,
    replanningStageState,
} from '~/state/atoms/adaptiveReplanningAtoms';

// The replanning stage on screen; undefined outside the step and while editing a propagated set.
export function useActiveReplanningStage(): ReplanningStage | undefined {
    const { currentStep } = useWorkflowSteps();
    const stageId = useRecoilValue(replanningStageState);
    const isEditingStructures = useRecoilValue(
        replanningEditingStructuresState
    );
    return currentStep?.id === 'adaptive-replanning' && !isEditingStructures
        ? replanningStage(stageId)
        : undefined;
}
